import { useTranslation } from 'react-i18next';

import { Moon, Sun } from 'lucide-react';

import { cn } from '@lemoment/ui-kit';

import { useThemeStore } from '../../../core/themeStore';

export const ThemeSelector = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useThemeStore();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className="flex w-full items-center justify-between rounded-xl px-2 py-2 text-left transition-colors hover:bg-lemon-soft/40"
    >
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-lemon-soft/70 text-lemon-ink dark:text-lemon">
          {isDark ? <Moon size={18} /> : <Sun size={18} />}
        </span>
        <div>
          <p className="font-display text-base font-semibold tracking-tight">
            {t('settings.theme')}
          </p>
          <p className="text-xs text-muted-foreground">
            {isDark ? t('settings.themeDark') : t('settings.themeLight')}
          </p>
        </div>
      </div>
      <div
        className={cn(
          'flex h-6 w-11 items-center rounded-full px-0.5 transition-colors',
          isDark ? 'bg-lemon' : 'bg-muted',
        )}
      >
        <div
          className={cn(
            'h-5 w-5 rounded-full bg-background shadow-sm transition-transform',
            isDark ? 'translate-x-5' : 'translate-x-0',
          )}
        />
      </div>
    </button>
  );
};
